import { isMysteryBundleItem } from '../../stores/rewards/helpers';
import type { ClaimableReward } from '../../stores/ui/types';

import type { MysteryResult } from './types';

/**
 * The rewards the claim screen shows: each Mystery item swapped for what it rolled (its coins added to the
 * reward it sat in, its items appended), each result used once. A Mystery item with no result is dropped — the prize
 * was still granted on the server and replays on the next app start.
 */
export const applyMysteryResults = (rewards: ClaimableReward[], results: MysteryResult[]): ClaimableReward[] => {
  const unused = [...results];
  return rewards.map((reward) =>
    reward.bundleItems.filter(isMysteryBundleItem).reduce<ClaimableReward>(
      (acc, item) => {
        const index = unused.findIndex((r) => r.mysteryId === item.bundlePayload.mysteryId);
        if (index === -1) return acc;
        const [result] = unused.splice(index, 1);
        return {
          gcCoin: acc.gcCoin + Number(result.rewards.gcCoin),
          scCoin: acc.scCoin + Number(result.rewards.scCoin),
          bundleItems: [
            ...acc.bundleItems,
            ...result.rewards.bundleItems.map((prize, prizeIndex) => ({
              ...prize,
              id: `mystery:${result.rollId}:${prizeIndex}`,
            })),
          ],
        };
      },
      { ...reward, bundleItems: reward.bundleItems.filter((item) => !isMysteryBundleItem(item)) },
    ),
  );
};

export const mysteryIdsOf = (rewards: ClaimableReward[]): string[] =>
  rewards.flatMap((reward) =>
    reward.bundleItems.filter(isMysteryBundleItem).map((item) => item.bundlePayload.mysteryId),
  );
